import { Link } from 'react-router-dom';
import { Customer } from '../../../domain/customers/customer';
import StatusLabel from '../../shared/components/StatusLabel';
import { ViewDetails } from '../../shared/components/ViewDetails';
import Table from '../../shared/components/table/Table';
import { Private_Routes } from '../../../main/constants';

interface Props {
    data: Customer[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export default function CustomerTable({
    data: customers,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                {
                    isSortable: true,
                    name: 'Code',
                    title: 'Código',
                },
                {
                    isSortable: true,
                    name: 'CommercialName',
                    title: 'Nombre Comercial',
                },
                {
                    isSortable: true,
                    name: 'DocumentNumber',
                    title: 'Numero de Identificación',
                },
                { isSortable: true, name: 'Address', title: 'Dirección' },
                { isSortable: false, name: 'Contacts', title: 'Contactos' },
                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {customers.map((customer) => (
                <tr key={customer.id}>
                    <td>{customer.code}</td>
                    <td>
                        {customer.commercialName}
                        {'  '}
                        <StatusLabel value={customer.isActive} />
                    </td>
                    <td>{customer.documentNumber}</td>
                    <td>{customer.address}</td>
                    <td className='aligns-item-center'>
                        <Link
                            title='Contactos'
                            to={`contacts/contacts-list/${customer.id}`}
                            style={{ display: 'flex', float: 'left' }}
                            className='btn btn-sm mx-3 mb-1 btn-primary'
                        >
                            <i
                                className='ri-phone-fill'
                                style={{
                                    marginRight: '2px',
                                }}
                            ></i>{' '}
                        </Link>
                    </td>
                    <td>
                        <ViewDetails
                            href={'/customers/update-customer/' + customer.id}
                        />
                    </td>
                </tr>
            ))}
        </Table>
    );
}
